import React from 'react';

interface StaffStatusData {
    active: number;
    onBreak: number;
    absent: number;
}

interface StaffStatusProps {
    data: StaffStatusData;
}

const StaffStatus: React.FC<StaffStatusProps> = ({ data }) => {
    const total = data.active + data.onBreak + data.absent;

    return (
        <div className="staff-status-card dashboard-card dashboard-card-wrapper coming-soon-card h-100">
            <div className="card-header d-flex align-items-center justify-content-between mb-3">
                <h5 className="card-title mb-0">
                    <i className="ri-team-line me-2"></i>
                    Current Staff Status
                </h5>
                <span className="text-muted">Today</span>
            </div>

            <div className="staff-status-content">
                <div className="status-summary d-flex justify-content-between mb-3">
                    <div className="status-item text-center">
                        <div className="status-circle active">
                            <i className="ri-checkbox-circle-fill"></i>
                        </div>
                        <div className="status-label">Active</div>
                        <div className="status-count fw-bold">{data.active}</div>
                    </div>

                    <div className="status-item text-center">
                        <div className="status-circle on-break">
                            <i className="ri-time-line"></i>
                        </div>
                        <div className="status-label">On Break</div>
                        <div className="status-count fw-bold">{data.onBreak}</div>
                    </div>

                    <div className="status-item text-center">
                        <div className="status-circle absent">
                            <i className="ri-close-circle-line"></i>
                        </div>
                        <div className="status-label">Absent</div>
                        <div className="status-count fw-bold">{data.absent}</div>
                    </div>
                </div>

                <div className="total-staff text-center mb-3">
                    <span className="text-muted">Total Staff: </span>
                    <span className="fw-bold">{total}</span>
                </div>
            </div>
        </div>
    );
};

export default StaffStatus;
